module.exports = __webpack_public_path__ + "img/devices-sprite.5c1cea90.svg";